const inspectTypeArr = [
  { name: '领导人姓名检查', label: 'leadername' },
  { name: '领导人排序检查', label: 'leadersort' },
  { name: '领导人职务检查', label: 'leadertitle' },
  { name: '敏感词检查', label: 'sentivewords' },
  { name: '重点词检查', label: 'keywords' },
  { name: '易错词检查', label: 'errorwords' },
  { name: '不规范名词检查', label: 'terms' },
  { name: '地名检查（曾用名）', label: 'placenameused' },
  { name: '地名检查（新旧地名不匹配）', label: 'placenamematch' },
  { name: '地名检查（所属区划错误）', label: 'placenamedivision' },
  { name: '地名检查（层级错误）', label: 'placenamelevel' },
  { name: '公元纪年错误', label: 'ADtime' },
  { name: '历史纪年错误', label: 'historytime' },
  { name: '干支纪年错误', label: 'branchtime' },
  { name: '标点符号检查', label: 'punctuation' },
  { name: '繁简误用', label: 'traditionalchinese' },
  { name: '异体字检查', label: 'variantchar' },
  { name: '译文检查', label: 'translation' }
]
const inspectTypeArrPie = [
  { name: '领导人姓名检查', label: 'leadername' },
  { name: '领导人排序检查', label: 'leadersort' },
  { name: '领导人职务检查', label: 'leadertitle' },
  { name: '敏感词检查', label: 'sentivewords' },
  { name: '重点词检查', label: 'keywords' },
  { name: '不规范名词检查', label: 'terms' },
  { name: '标点符号检查', label: 'punctuation' },
  { name: '繁简误用', label: 'traditionalchinese' },
  { name: '异体字检查', label: 'variantchar' },
  { name: '易错词检查', label: 'errorwords' },
  { name: '地名检查（曾用名）', label: 'placenameused' },
  { name: '地名检查（新旧地名不匹配）', label: 'placenamematch' },
  { name: '地名检查（所属区划错误）', label: 'placenamedivision' },
  { name: '地名检查（层级错误）', label: 'placenamelevel' },
  { name: '公元纪年错误', label: 'ADtime' },
  { name: '历史纪年错误', label: 'historytime' },
  { name: '干支纪年错误', label: 'branchtime' },
  { name: '译文检查', label: 'translation' }
]
export { inspectTypeArr, inspectTypeArrPie }
